import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import axios from 'axios';
import axiosAuthRefresh from 'axios-auth-refresh';
import secureLocalStorage from 'react-secure-storage';
import { getEnv } from './env.js';
import { toast } from 'react-toastify';

// const demoUrl = 'https://demo-api.ima360.app/v1/api/'; //local purposegit
// const localBaseUrl = "http://3.22.165.7:8080/v1/api/"; //local purposegit
// const localBaseUrl = 'https://dev-api.ima360.app/v1/api/'; //local purposegit
var baseUrl = getEnv();
// Create an instance of Axios  

const axiosInstance = axios.create({
  baseURL: baseUrl['BASE_URL'],
  // baseURL: localBaseUrl,
  // baseURL: demoUrl,
}); let isRefreshing = false;
let refreshPromise = null; // store the refresh call promise

const refreshAccessToken = async (failedRequest) => {
  const refreshToken = secureLocalStorage.getItem('rFtk');

  // 🔒 Prevent multiple refresh calls - check and set atomically
  if (isRefreshing && refreshPromise) {
    // Wait for the ongoing refresh to finish
    return refreshPromise.then((newAccessToken) => {
      failedRequest.response.config.headers.Authorization = `Bearer ${newAccessToken}`;
      return axios(failedRequest.response.config);
    }).catch((error) => {
      // If refresh failed, reject the request
      return Promise.reject(error);
    });
  }

  // Set flag immediately to prevent race condition
  isRefreshing = true;
  refreshPromise = (async () => {
    try {
      const response =
        secureLocalStorage.getItem('user_type') === 'okta'
          ? await axiosInstance.post('okta/token', {
            grant_type: 'refresh_token',
            refresh_token: refreshToken,
          })
          : await axiosInstance.post('refresh', {
            refresh_token: refreshToken,
          });

      const newAccessToken = response.data.response.access_token;
      localStorage.setItem('accessToken', newAccessToken);
      secureLocalStorage.setItem('aTk', newAccessToken);
      return newAccessToken;
    } catch (error) {
      // Reset state on error so retry can happen
      isRefreshing = false;
      refreshPromise = null;
      throw error;
    } finally {
      // Reset flag after refresh completes (success or failure)
      // This allows future 401s to trigger a new refresh
      isRefreshing = false;
    }
  })();

  // ✅ Once refresh completes, retry the failed request
  return refreshPromise.then((newAccessToken) => {
    failedRequest.response.config.headers.Authorization = `Bearer ${newAccessToken}`;
    return axios(failedRequest.response.config);
  }).catch((error) => {
    // If refresh failed, reject the request
    return Promise.reject(error);
  });
};

//  handle all error toasts
const showErrorToast = (error) => {
  // Opt-out for callers that render the rejection themselves (e.g. as field
  // errors) — pass `suppressErrorToast: true` in the request config.
  if (error.config?.suppressErrorToast) return;

  if (error.response && error.response.data) {
    const data = error.response.data;

    if (data.complete_error_message) {
      let message = data.complete_error_message;

      if (typeof message === 'string' && message.includes('\n')) {
        const formattedMessage = message.split('\n').map((line, index) => (
          <span key={index}>{line}<br /></span>
        ));
        toast.error(<>{formattedMessage}</>);
      } else {
        toast.error(message);
      }
    } else if (data.error && data.error.message) {
      toast.error(data.error.message);
    }
  }
};

// Add a response interceptor to handle token expiration or any other response-related logic
axiosInstance.interceptors.response.use(
  (response) => {
    // Handle the response data or perform any modifications
    return response;
  },
  (error) => {
    // Check if the error is due to an expired token (e.g., 401 Unauthorized)
    if (error.response && error.response.status === 401) {
      // Trigger the token refresh logic
      return refreshAccessToken(error).catch((refreshError) => {
        // Handle the error when refreshing the token
        // If refresh fails, user needs to re-authenticate
        if (refreshError.response && refreshError.response.status === 401) {
          // Refresh token also expired - clear tokens and redirect to login
          secureLocalStorage.removeItem('rFtk');
          localStorage.removeItem('accessToken');
          // toast.error('Session expired. Please login again.');
        }
        else {
          // If the retried request fails with a standard error, show it!
          showErrorToast(refreshError);
        }
        return Promise.reject(refreshError);
      });
    }
    //  For all other errors on the FIRST attempt, show the toast
    showErrorToast(error);
    // Handle other error cases
    return Promise.reject(error);
  },
);

export default axiosInstance;